import { Component } from '@angular/core';
import { SetupGuideStep } from '../setup-guide/setup-guide.component';

/**
 * Page wrapper for the PayBright integration settings.
 *
 * Hosts the settings form alongside the shared setup guide inside the standard
 * configuration page shell.
 */
@Component({
  selector: 'app-integration-paybright',
  templateUrl: './integration-paybright.component.html',
  styleUrls: ['./integration-paybright.component.css'],
})
export class IntegrationPaybrightComponent {
  setupSteps: SetupGuideStep[] = [
    {
      num: 1,
      title: 'Find your PayBright details',
      body: `Sign in to your PayBright account and open <strong>Source Management</strong>. Copy your
             <strong>source key</strong> (and PIN, if you have one).`,
      open: true,
    },
    {
      num: 2,
      title: 'Enter your details',
      body: `Paste your source key and PIN into <strong>Your PayBright details</strong>, then enter your
             terminal's <strong>serial number</strong> (printed on the back of the reader).`,
    },
    {
      num: 3,
      title: 'Check & save',
      body: `Click <strong>Check Connection</strong> to make sure everything works, switch on
             <strong>Accept PayBright terminal payments</strong>, and click <strong>Save Settings</strong>.`,
    },
    {
      alt: true,
      title: 'Turning it off',
      body: `Switch off <strong>Accept PayBright terminal payments</strong> and save. PayBright will no
             longer appear as a payment option for this studio.`,
    },
  ];
}
